module.exports = __webpack_public_path__ + "static/formSocial-0ea7a1bc389e626255f709eb64ed3520.jpg";